<template>
  <div class="pv">
    <div
      v-for="(s, i) in stores"
      :key="s.n"
      class="pv__row"
      :class="{ 'pv__row--on': i < step }"
    >
      <span class="pv__dot" :class="{ 'pv__dot--on': i < step }"></span>
      <span class="pv__name" :class="{ 'pv__name--on': i < step }">{{ s.n }}</span>
      <span class="pv__plat" :class="{ 'pv__plat--on': i < step }">{{ s.p }}</span>
      <span v-if="i < step" class="pv__gmv">¥{{ gmv[i].toLocaleString() }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrevStores',
  props: { run: { type: Boolean, default: false } },
  data() {
    return {
      step: 0,
      gmv: [0, 0, 0, 0],
      timer: null,
      countTimers: [],
      stores: [
        { n: '观星树小店', p: '抖店', gmv: 28640 },
        { n: '观星树旗舰', p: '淘宝', gmv: 18320 },
        { n: '观星树精品铺', p: '京东', gmv: 9876 },
        { n: '观星树好物汇', p: '拼多多', gmv: 5430 }
      ]
    }
  },
  watch: {
    run(v) {
      this.clearAll()
      if (!v) { this.step = 0; this.gmv = [0, 0, 0, 0]; return }
      this.timer = setInterval(() => {
        this.step = Math.min(this.step + 1, this.stores.length)
        if (this.step >= this.stores.length) clearInterval(this.timer)
      }, 600)
    },
    step(val) {
      if (val === 0) return
      const target = this.stores[val - 1].gmv
      let cur = 0
      const t = setInterval(() => {
        cur += Math.ceil(target / 20)
        if (cur >= target) { cur = target; clearInterval(t) }
        this.$set(this.gmv, val - 1, cur)
      }, 50)
      this.countTimers.push(t)
    }
  },
  methods: {
    clearAll() {
      if (this.timer) clearInterval(this.timer)
      this.countTimers.forEach(t => clearInterval(t))
      this.countTimers = []
    }
  },
  beforeDestroy() {
    this.clearAll()
  }
}
</script>

<style scoped>
.pv { display: flex; flex-direction: column; gap: 6px; width: 100%; }
.pv__row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 10px;
  border-radius: 8px;
  background: rgba(255, 255, 255, .03);
  border: 1px solid rgba(255, 255, 255, .07);
  transition: all .4s;
}
.pv__row--on { background: rgba(212, 169, 70, .06); border-color: rgba(212, 169, 70, .3); }
.pv__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(255, 255, 255, .2);
  flex-shrink: 0;
  transition: all .3s;
}
.pv__dot--on { background: #4CAF7A; box-shadow: 0 0 6px #4CAF7A; }
.pv__name { font-size: 11px; flex: 1; color: rgba(240, 230, 210, .35); transition: color .3s; }
.pv__name--on { color: rgba(240, 230, 210, .85); }
.pv__plat { font-size: 9px; color: rgba(255, 255, 255, .2); transition: color .3s; }
.pv__plat--on { color: #00C8F5; }
.pv__gmv { font-family: Inter, monospace; font-size: 11px; color: #D4A946; font-weight: 600; }
</style>
